import React from 'react'
import PropTypes from 'prop-types'
import { includes } from 'lodash'
import moment from 'moment'
import { Button, Text, DatePickerField, Form } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { formatDate } from '../../utils/date'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const ALL_KEY = 'all'

const AuctionDates = ({ elmId, dates, selected, onSelectDate }) => {
  const isInvalidAuctionDate = date => {
    return !includes(dates, moment(date).format(moment.HTML5_FMT.DATE))
  }

  const onSelect = selectedDate => {
    const newSelectedDate =
      selectedDate === ALL_KEY
        ? ''
        : moment(selectedDate).format(moment.HTML5_FMT.DATE)

    if (newSelectedDate !== selected) {
      onSelectDate(newSelectedDate)
    }
  }

  const onChangeDatePicker = date => {
    onSelectDate(date ? moment(date).format(moment.HTML5_FMT.DATE) : '')
  }

  if (!dates || dates.length === 0) {
    return null
  }

  const selectedDate = selected
    ? new Date(moment(selected, 'YYYY-MM-DD'))
    : null

  const dateTabs = dates.map((date, index) => (
    <Button
      size='small'
      key={date}
      elmId={`${elmId}_auction_dates_toggle_${date}`}
      value={date}
      onClick={() => onSelect(dates[index])}
      isSelected={selected === date}
    >
      <Text>{formatDate(date, 'MMM Do, YYYY')}</Text>
    </Button>
  ))

  return (
    <div className={cx('auction-dates-container')}>
      <div className={cx('hide-on-tablet')}>
        <Button.Group data-elm-id={elmId + '_auction_dates_toggle_container'}>
          <Button
            size='small'
            key={ALL_KEY}
            value={ALL_KEY}
            onClick={() => onSelect(ALL_KEY)}
            elmId={elmId + '_auction_dates_toggle_all'}
            isSelected={!selected}
          >
            <Text>All</Text>
          </Button>
          {dateTabs}
        </Button.Group>
      </div>
      <Form>
        <DatePickerField
          elmId={elmId + '_auction_dates_input_mobile'}
          className={cx('show-on-tablet', 'auction-dates-datepicker')}
          value={selectedDate}
          onChange={onChangeDatePicker}
          orientation='bottom'
          disabledDays={isInvalidAuctionDate}
        />
      </Form>
    </div>
  )
}

AuctionDates.propTypes = {
  elmId: PropTypes.string.isRequired,
  dates: PropTypes.array.isRequired,
  selected: PropTypes.string,
  onSelectDate: PropTypes.func.isRequired,
}

export default AuctionDates
